import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';
import {
    StopRequestLine,
    UNATTRIBUTED_STOP_REQUEST_COPY,
} from '@apps/web/features/phoebe_chat_v3/ui/primitives/stop_request_line';

const payloadSchema = z.object({
    reason: z.string().nullable().optional(),
});

export const stopRequestedDefinitions = {
    stop_requested: defineStandalone('stop_requested', {
        disposition: 'render',
        schema: payloadSchema,
        malformed: {
            kind: 'placeholder',
            customerCopy: UNATTRIBUTED_STOP_REQUEST_COPY,
        },
        evidence(_payload, occurrence) {
            const source = occurrence.committed ?? occurrence.pending;
            if (source === null) {
                return null;
            }
            return {
                kind: 'interrupt_requested',
                occurredAtMs: Date.parse(source.created_at),
            };
        },
        group: null,
        render(_payload, occurrence) {
            const sentBy = occurrence.committed?.sent_by ?? null;
            return (
                <StopRequestLine
                    userId={
                        sentBy?.user_id ??
                        occurrence.pending?.enqueued_by_user_id ??
                        null
                    }
                    displayName={sentBy?.display_name ?? null}
                />
            );
        },
    }),
} as const;

export const stopRequestedContractFixtures = {
    valid: {
        type: 'stop_requested',
        reason: 'stop-reason-sentinel',
    },
    malformed: {
        type: 'stop_requested',
        reason: 9,
    },
} as const;
